<template>
  <div style="padding-top: 130px;">
    <div class="login-container">
      <div class="top">
        <img src="../assets/img/logo.png" alt="icon" width="100" height="100">
      </div>
      <div  v-show="!switches">
        <el-form :model="ruleForm" status-icon :rules="rulesCode" ref="ruleForm1" label-position="left"
        >
          <el-form-item prop="username">
            <el-input type="username" v-model="ruleForm.username" auto-complete="off" placeholder="账号/手机号" autofocus="true"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item >
            <el-col :span="11">
              <el-form-item prop="code">
                <el-input type="input" v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <div class="imgCode"  @click="getImg">
                点击显示验证码
                <img :src="img" style="position: relative;top: -40px;">
              </div>
            </el-col>
          </el-form-item>
          <!--<el-checkbox checked class="remember">记住密码</el-checkbox>-->
          <el-form-item>
            <el-button type="primary" :loading="loading" style="width:100%;" @click.prevent="login('ruleForm1')" >登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="switches">
        <el-form :model="ruleForm" status-icon :rules="rulesPhone" ref="ruleForm" label-position="left"
        >
          <el-form-item prop="phone">
            <el-input type="number" v-model="ruleForm.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item >
            <el-col :span="11">
              <el-form-item prop="phonecode">
                <el-input type="input" v-model="ruleForm.phonecode" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-button type="primary" :disabled="isAnable" :loading="isAnable" plain @click="sendMobileCode">{{msg}}</el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" style="width:100%;" @click.prevent="phoneLogin('ruleForm')" >登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-switch
        style="display: block;margin: 0px 0px 20px 0px"
        v-model="switches"
        active-color="#13ce66"
        inactive-color="#409efb"
        active-text="手机登录"
        inactive-text="账号登录"
        @change="switchType" >
      </el-switch>
      <div class="footer-links" style="text-align: center">
        <router-link to="/"><span style="float: right"><i class="el-icon-sort"></i> 返回首页</span></router-link>
        <router-link to="/register"><span style="float: left"><i class="el-icon-edit-outline"></i> 注册</span></router-link>
        <router-link to="/forget"><span>忘记密码 ?</span></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {getPhoneCode, getImageCode} from '../api/login'
import {uuid} from '@/utils/util'

export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      msg: '发送验证码',
      switches: false,
      ruleForm: {
        username: '',
        password: '',
        code: '',
        phonecode: '',
        phone: '',
        UUID: uuid()
      },
      rulesCode: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      rulesPhone: {
        phone: [
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '电话格式不正确', trigger: ['blur']},
          { required: true, message: '电话号码不能为空', trigger: 'blur' }
        ],
        phonecode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      img: '',
      timeOut: {},
      loading: false,
      isAnable: false
    }
  },
  created () {
    this.getImg()
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    login (formName) {
      let _this = this
      _this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.Userlogin(_this.ruleForm).then(function (response) {
            _this.$router.push({ path: '/' })
            _this.loading = false
          }).catch(() => {
            _this.loading = false
            _this.ruleForm.code = ''
            _this.getImg()
          })
        } else {
          _this.loading = false
        }
      })
    },
    phoneLogin (formName) {
      let _this = this
      _this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.UserPhonelogin(_this.ruleForm).then(function () {
            _this.$router.push({ path: '/' })
            _this.loading = false
          }).catch(() => {
            _this.loading = false
            _this.ruleForm.phonecode = ''
          })
        } else {
          _this.loading = false
        }
      })
    },
    sendMobileCode () {
      let _this = this
      this.$refs['ruleForm'].validateField(['phone'], (valid) => {
        if (!valid) {
          _this.isAnable = true
          _this.msg = '发送中...'
          getPhoneCode(_this.ruleForm.phone, _this.ruleForm.UUID).then(res => {
            _this.msg = '已发送'
            _this.isAnable = true
            setTimeout(() => {
              _this.msg = '发送验证码'
              _this.ruleForm.phonecode = ''
              _this.isAnable = false
            }, 60000)
            // _this.msg = '发送中...'
          }).catch(() => {
            setTimeout(() => {
              _this.msg = '发送验证码'
              _this.ruleForm.phonecode = ''
              _this.isAnable = false
            }, 2000)
          })
        }
      })
    },
    getImg () {
      let _this = this
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        getImageCode(_this.ruleForm.UUID).then(function (response) {
          _this.img = 'data:image/png;base64,' + btoa(
            new Uint8Array(response.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
        })
      }, 500)
    },
    switchType () {
      this.$refs.ruleForm.resetFields()
      this.$refs.ruleForm1.resetFields()
    },
    ...mapActions({Userlogin: 'user/login', UserPhonelogin: 'user/loginphone', loginOut: 'user/logOut'})
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .top
    text-align: center
    padding: 0px 0 20px
  .login-container
    border-radius: 5px
    background-clip: padding-box
    margin: auto
    width: 320px
    padding: 35px 35px 15px 35px
    background: #fff
    border: 1px solid #ddd
    .imgCode
      width 100%
      height 40px
    .remember
      margin: 0px 0px 20px 0px
    .footer-links
      a
        color: #b9b9b9
        font-size: 13px
        text-decoration none
        &:hover
          color #1a191f
</style>
